<template>
  <div class="classlayout">
    <el-main>
    <div class="div">
      <el-button type="primary" @click="addClass">+&nbsp;新增</el-button>
    </div>
      <div class="div2">
        <span>学段</span>
        <div class="btn">
            <el-radio-group v-model="stageId" @change="changeit">
              <el-radio-button :label="item.id"  v-for="(item,index ) in stages"  :key="index" >{{item.name}}</el-radio-button>
            </el-radio-group>
        </div>
      </div>
    <el-table
      :data="tableData"
      :height="height"
      v-loading="loading"
      header-row-class-name="header-row-class-name"
      :default-sort = "{prop: 'id', order: 'descending'}"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        sortable
        label="ID号">
      </el-table-column>
      <el-table-column
        prop="ordinal"
        sortable
        label="排序号（可编辑）">
      </el-table-column>
      <el-table-column
        prop="name"
        label="科目名">
      </el-table-column>
      <el-table-column
        label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.used === true" style="color: #00ff00"> 启用</span>
          <span v-if="scope.row.used === false" style="color: #ff0000">禁用</span>
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作">
        <template slot-scope="scope">
          <el-button  type="text" size="small" @click="editClass(scope.row.id,scope.row)">编辑</el-button>
          <el-button  type="text" size="small" @click="disable(scope.row.id)" v-if="scope.row.used == true">禁用</el-button>
          <el-button  type="text" size="small" @click="enable(scope.row.id)" v-if="scope.row.used == false">启用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑框 -->
    <edit-dialog  v-model="classDialogVisible" :stageId="stageId" :rowData="rowData" :id="id" @success="editSuccess"></edit-dialog>
  </el-main>
  </div>
</template>
<script type="text/babel">
import editDialog from './edit-dialog'
import classService from '@/service/classService'
import commonService from '@/service/commonService'
export default {
  components: {
    editDialog: editDialog
  },
  name: 'classManage',
  data () {
    return {
      id: 0,
      rowData: {},
      height: this.SysConstant.winHeight - 280,
      stageId: 0,
      record: {},
      classDialogVisible: false,
      tableData: [],
      stages: [],
      subjects: [],
      loading: false
    }
  },
  async mounted () {
    // 查询
    await this.fetchLearnData()
    await this.fetchData()
  },
  methods: {
    async fetchLearnData () {
      this.loading = true
      try {
        let data = await commonService.fetchCommonStage()
        if (data) {
          this.stageId = data[1].id
          this.stages = data
        } else {
          this.stages = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
      this.loading = false
    },
    changeit () {
      this.fetchData()
    },
    async fetchData () {
      try {
        let data = await classService.fetchData(this.stageId)
        if (data) {
          this.tableData = data
        } else {
          this.tableData = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 启用
    async enable (id) {
      try {
        await classService.enableOrDisable({id: id, use: true})
        this.$message.success(this.SysConstant.success)
        this.fetchData()
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 禁用
    async disable (id) {
      this.$confirm('此操作将禁用该科目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await classService.enableOrDisable({id: id, use: false})
        this.$message.success(this.SysConstant.success)
        this.fetchData()
      }).catch((e) => {
      //  this.$message.error(e && e.msg)
      })

      // try {
      //   await classService.enableOrDisable({id: id, use: false})
      //   this.$message.success(this.SysConstant.success)
      //   this.fetchData()
      // } catch (e) {
      //   this.$message.error(e && e.msg)
      // }
    },
    addClass () {
      this.id = 0
      this.classDialogVisible = true
    },
    editClass (id, row) {
      this.id = id
      this.rowData = row
      this.classDialogVisible = true
    },
    editSuccess () {
      this.id = 0
      this.rowData = {}
      this.classDialogVisible = false
      this.$message.success(this.SysConstant.success)
      this.fetchData()
    }
  }
}
</script>
<style scoped>
  .classlayout .div{
    background-color: #ffffff;
    color: #333;
    line-height: 60px;
    height:60px;
    margin-top:-10px;
    margin-bottom:5px;
  }
  .classlayout .div{
    margin-top:-10px;
  }
  .classlayout .div .el-button{
    background-color: #00aaff;
    color:#fff;

    margin:10px;
    float:left;
  }
  .classlayout .div2{
    overflow: hidden;
    background-color: #ffffff;
    color: #333;
    line-height:60px;
    margin:5px 0;
  }
  .classlayout .div2 span{
    margin:0px 40px;
    float:left;
  }
  .classlayout .div2 .btn{
    float:left;
    width: 80%;
  }
  .classlayout .div2 .active{
    background-color: #00aaff;
    color:#fff;
  }

</style>
<style type="text/css">
  .classlayout .div2 .el-radio-button{
    margin:10px 10px;
    border:none !important;
    border-radius:4px !important;
  }
  .classlayout .el-radio-button__inner{

    border: 1px solid #dcdfe6;
  }
</style>



// WEBPACK FOOTER //
// src/pages/layout/class-manage/index.vue